//email Regex
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//mobile number Regex
export const mobileNumberRegex = /^[6789][0-9]{9}$/;

//string Regex
export const stringOnlyRegex = /^[a-zA-Z\s]+$/;
